const DOMAIN = "https://mayedo.ci";

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "SCI MAYEDO",
  url: DOMAIN,
  logo: `${DOMAIN}/images/27.png`,
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+225-0777880082",
    contactType: "customer service",
    availableLanguage: ["French"],
  },
  address: {
    "@type": "PostalAddress",
    addressCountry: "CI",
    addressLocality: "Abidjan",
  },
  sameAs: [],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "SCI MAYEDO",
  url: DOMAIN,
  potentialAction: {
    "@type": "SearchAction",
    target: `${DOMAIN}/louer?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export function realEstateListingSchema(home) {
  if (!home) return null;
  return {
    "@context": "https://schema.org",
    "@type": "Accommodation",
    name: home.nameHome || home.label || home.title || "Bien immobilier",
    description: home.description || `${home.nameHome || "Bien immobilier"} à ${home.city || "Abidjan"} — SCI MAYEDO`,
    image: Array.isArray(home.img) ? home.img[0] : (home.img || `${DOMAIN}/images/27.png`),
    url: `${DOMAIN}/details/${home._id}`,
    address: {
      "@type": "PostalAddress",
      addressLocality: home.city || "Abidjan",
      addressCountry: "CI",
      streetAddress: home.addressHome || "",
    },
    numberOfRooms: home.NmbrePieces || undefined,
    amenityFeature: home.amenities || [],
    offers: {
      "@type": "Offer",
      priceCurrency: "XOF",
      price: home.rent || home.price || 0,
      priceSpecification: {
        "@type": "UnitPriceSpecification",
        price: home.rent || home.price || 0,
        priceCurrency: "XOF",
        referenceQuantity: {
          "@type": "QuantitativeValue",
          value: 1,
          unitCode: "MON",
        },
      },
      availability: "https://schema.org/InStock",
      seller: {
        "@type": "Organization",
        name: "SCI MAYEDO",
        url: DOMAIN,
      },
    },
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: `${DOMAIN}${item.path}`,
    })),
  };
}
